import { useState } from 'react';
import type { WidgetDef } from '../api';
import { pinToHome } from '../pin';

/** Knop "Op mijn startscherm": zet deze lijst als rij op Home van dit profiel. */
export function PinButton({ title, source, view = 'poster' }: { title: string; source: WidgetDef['source']; view?: WidgetDef['view'] }) {
  const [state, setState] = useState<'idle' | 'busy' | 'done' | 'error'>('idle');
  return (
    <button
      className="btn btn-sm"
      disabled={state === 'busy' || state === 'done'}
      onClick={() => {
        setState('busy');
        pinToHome(title, source, view).then(() => setState('done')).catch(() => setState('error'));
      }}
    >
      {state === 'done' ? '✓ Op je startscherm' : state === 'error' ? 'Mislukt, opnieuw?' : state === 'busy' ? 'Bezig…' : '📌 Op mijn startscherm'}
    </button>
  );
}
